import {
  initialType,
  KioskBookingSuccessDetails,
  PendingSlotSelection,
} from "@models/services/kiosk";
import { CaseReducer, createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: initialType = {
  bookingSuccessDetails: {
    bookingId: "",
    showModal: false,
  },
  isSlotsLoading: false,
  kioskBookingJustSaved: false,
  pendingSlotSelection: null,
  showLoginModal: false,
};

type kioskSliceReducer<Payload> = CaseReducer<
  initialType,
  PayloadAction<Payload>
>;

const setKioskBookingJustSaved: kioskSliceReducer<boolean> = (
  state,
  action
) => {
  state.kioskBookingJustSaved = action.payload;
};

const setShowLoginModal: kioskSliceReducer<boolean> = (state, action) => {
  state.showLoginModal = action.payload;
};

const setBookingSuccessDetails: kioskSliceReducer<
  KioskBookingSuccessDetails
> = (state, action) => {
  state.bookingSuccessDetails = action.payload;
};

const setPendingSlotSelection: kioskSliceReducer<
  PendingSlotSelection | null
> = (state, action) => {
  state.pendingSlotSelection = action.payload;
};

const setIsSlotsLoading: kioskSliceReducer<boolean> = (state, action) => {
  state.isSlotsLoading = action.payload;
};

export const kioskSlice = createSlice({
  initialState,
  name: "kiosk",
  reducers: {
    setBookingSuccessDetails,
    setIsSlotsLoading,
    setKioskBookingJustSaved,
    setPendingSlotSelection,
    setShowLoginModal,
  },
});

export default kioskSlice;
